import $ from 'jquery';
import axios from 'axios';
import anime from 'animejs/lib/anime.es.js';

// $( '#lookupBtn' ).click( function( event ) {
// 	console.log('click');
// 	event.preventDefault();
// 	// submitForm( $( '#lookupForm' ) );
// } );
//
function submitForm( form ) {
	if ( validateForm( form ) ) {
		form.submit();
	}
}
//
function validateForm( form ) {
	if ( $( '#lookupInput' ).val() !== '' ) {
		let lookup = decodeURI($( '#lookupInput' ).val());
		// let arr = lookup.split('/');
		// let ip = arr[0];
		// let range = arr[1];
		// console.log(ip + " - " + range);
		// $( '#lookupInput' ).val(ip);
		// $( '#lookupRange' ).val(range);
		// form.submit();
		return true;
	}
	return false;
}

if (document.getElementById('lookupForm') !== null) {
	const blForm = document.getElementById('lookupForm');

	blForm.addEventListener('submit', function(e) {
		e.preventDefault();
		submitForm( $( '#lookupForm' ) );
	});
}

$(document).ready( function () {
	// Whois Lookup
	$('#whoisLookup').on('click', function() {
		$('.rpLoaderWrapper').show();
		$('.c-popup__text').hide();
		let resource = $('#lookupResource').text();
		$('#mdl-whois .c-popup__text span').html("");
		$('#mdl-whois .c-popup__text p').html("");
		let whoisCopy = '';
		let whoisCopyRegistry = '';
		// Get data from API
    axios.get('https://api.returnpath.com/v2/sender-score/whois/'+ resource, {crossDomain: true})
    .then(response =>  {
			$('.rpLoaderWrapper').hide();
			$('.c-popup__text').fadeIn();
			// Grab type of record: Domain or IP
			let type = Object.keys(response.data)[0];
			// Set vars
			if (type === 'domain') {
				if (response.data['domain']['WhoisRecord']['rawText'] !== undefined) {
					whoisCopy = response.data['domain']['WhoisRecord']['rawText'];
				}
				if (response.data['domain']['WhoisRecord']['registryData']['rawText'] !== undefined) {
					whoisCopyRegistry = response.data['domain']['WhoisRecord']['registryData']['rawText'];
				}
			} else { //is IP
				if (response.data['ip']['WhoisRecord']['rawText'] !== undefined) {
					whoisCopy = response.data['ip']['WhoisRecord']['rawText'];
				}
				if (response.data['ip']['WhoisRecord']['registryData']['rawText'] !== undefined) {
				  whoisCopyRegistry = response.data['ip']['WhoisRecord']['registryData']['rawText'];
				}
			}

			// Convert newline to breaks
			if (whoisCopy !== '') {
				whoisCopy = whoisCopy.replace(/\n/g, "<br />");
			}
			if (whoisCopyRegistry !== '') {
				whoisCopyRegistry = whoisCopyRegistry.replace(/\n/g, "<br />");
			}

			let copy = whoisCopyRegistry + whoisCopy;

			$('#mdl-whois .c-popup__text span').html(resource);
			$('#mdl-whois .c-popup__text p').html(copy);
    })
  });


	// SS Donut Chart
	if (typeof d3 !== 'undefined' && typeof c3 !== 'undefined') {
		if ($('#rpSenderScoreChart').length > 0) {
	    $('#rpSenderScoreChart').each(function(i, chart) {
        var $chart = $(chart),
          	$svg = $chart.find('svg');

        var obj = { stat: 0 },
          	primary = $svg.data('primary');

        $svg.find('.anim').each(function(i, circle) {
          var r = circle.getAttribute('r'),
          		c = 2 * Math.PI * r,
          		value = circle.getAttribute('data-value'),
          		percent = 1 - (value / 100),
		          props = {
		            targets: circle,
		            strokeDashoffset: [anime.setDashoffset, c * percent],
		            easing: 'easeInOutSine',
		            duration: 1500,
		            loop: false
		          };

          anime(props);
        });

        anime({
          targets: obj,
          stat: primary,
          round: 1,
          easing: 'linear',
          duration: 1500,
          update: function() {
              $chart.find('h2')[0].innerHTML = obj.stat;
          }
        });
	    });
		}
	}

	// Trend chart
	if ($('#rpTrendChart').length > 0 && ssData.hasOwnProperty('ss_trend') && ssData.hasOwnProperty('ss_volume_trend')) {
	  var time = ['x'],
	      score = ['Score'],
	      volume = ['Volume'];

	  ssData.ss_trend.forEach(function(point) {
      if (point != null) {
        time.push(point.timestamp);
        score.push(point.value);
      }
	  });

	  ssData.ss_volume_trend.forEach(function(point) {
      if (point != null) {
        volume.push(point.value);
      }
	  });

	  var ssTrendChart = c3.generate({
      bindto: '#rpTrendChart',
      data: {
        x: 'x',
        columns: [],
        axes: {
          Score: 'y',
          Volume: 'y2'
        }
      },
      axis: {
        x: {
	        tick: {
            count: 5,
            format: function (x) {
              var date = new Date(x);
              return date.toDateString();
            }
          }
        },
        y2: {
          show: true
        }
      },
      color: {
        pattern: [ssData.color, '#00a3e0', '#008c95', '#00965e']
      }
	  });

	  setTimeout(function () {
      ssTrendChart.load({
        columns: [time, score]
      });
	  }, 500);

	  setTimeout(function () {
      ssTrendChart.load({
        columns: [time, volume]
      });
	  }, 1000);
	}


}); // end doc ready
